import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Inject } from '@angular/core';
import { MsalService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import { RedirectRequest } from '@azure/msal-browser';
import { MsalInteractionService } from '../../Services/Auth/msal-interaction.service';

@Component({
  standalone: false,
  selector: 'app-session-expired-error',
  templateUrl: './session-expired.component.html',
  styleUrls: ['./session-expired.component.scss'],
})
export class SessionExpiredComponent implements OnInit {
  constructor(
    private router: Router,
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private msalService: MsalService,
    private msalInteractionService: MsalInteractionService
  ) {}

  ngOnInit(): void {
    const navEntry = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming;
    const isPageReload = navEntry?.type === 'reload' || performance.navigation?.type === 1;

    if (isPageReload) {
      this.router.navigate(['/home']);
      return;
    }
  }

  signIn(): void {
    const request = {
      ...(this.msalGuardConfig.authRequest ?? {}),
      redirectStartPage: '/home',
    } as RedirectRequest;

    this.msalInteractionService.clearStaleInteraction();
    this.msalService.loginRedirect(request);
  }

  close(): void {}
}
